<section class="w-full flex flex-wrap justify-center items-center">
    <div class="w-full flex flex-wrap content-start bg-white dark:bg-gray-900 rounded-lg pt-4 pb-4 px-4">
        <div class="w-full flex flex-wrap">
            <img class="w-6" src=".https://cloud.behkhaan.ir/assets/icons/beh-logo.svg">
            <p class="w-full font-bold text-sm text-[#03121B] dark:text-white mt-4">لیست | {{data.title}}</p>
        </div>
        <div class="w-full flex flex-wrap mt-[17px] justify-between border-b border-[#CED3D7] pb-4">
            <div class="flex items-center">
                <span class="icon ruled-paper-regular text-green-500 ml-2"></span>
                <span class="font font-medium text-xs text-gray-500 dark:text-gray-400 ml-[2px]">{{data.count}}</span>
                <span class="font font-medium text-xs text-gray-500 dark:text-gray-400">کتاب</span>


            </div>
            <span class="font-regular text-xs text-gray-500 dark:text-gray-400">{{data.actor?.userName + '@' }}</span>
            <p class="w-full font-medium text-xs text-gray-700 dark:text-gray-300 mt-3">{{data.description}}</p>
        </div>

        <div class="w-full flex flex-wrap justify-between mt-4">
            @for (book of data.books; track $index; let idx = $index) {
            <img class="aspect-[0.67] h-24 rounded" [src]="book.book?.id| image : imageType.book : book.book.hasPhoto">
            }

        </div>
    </div>
    <div class="flex flex-wrap flex-col justify-center items-center mt-4">
        <p class="text-xs text-gray-700 dark:text-gray-200 font-medium">بهخوان | شبکهٔ اجتماعی کتاب</p>

        <div class="relative w-full my-4">
            <div class="border-t border-gray-500 dark:border-gray-400 absolute top-1/2 left-0 right-0"></div>
            <p
                class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-green-10 dark:bg-green-1000 px-2 text-green-500 text-sm font-medium">
                behkhaan.ir</p>
        </div>
    </div>
</section>